module.exports = __webpack_public_path__ + "static/media/servicing2.dce04d7e.jpg";